import { GeoCoords } from "common/utils/Map";
import { Geocode, GeocodeCoords, Geocoder } from "../types";
import config from "config";

export class HereGeocoder implements Geocoder {
  private _service: any;

  constructor() {
    this._service = new window.H.service.Platform({
      apikey: config.hereAppKey,
    });
  }
  geocode!: Geocode;

  geocodeCoords: GeocodeCoords = async (coords: GeoCoords) => {
    const searchService = this._service.getSearchService(null);

    return new Promise((resolve, reject) => {
      searchService.reverseGeocode(
        {
          at: `${coords.lat},${coords.lng}`,
          lang: "en",
        },
        ({ items }: any) => {
          resolve({ address: items[0]?.title ?? "" });
        },
        reject
      );
    });
  };
}
